const MIDNIGHT_TIME_PATTERN =
  /^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.000)?(?:Z|[+-]\d{2}:\d{2})?$/;

const getInclusiveDiscountEnd = (value) => {
  if (!value) {
    return null;
  }

  const rawValue = String(value).trim();
  const parsedDate = new Date(rawValue);

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  if (!MIDNIGHT_TIME_PATTERN.test(rawValue)) {
    return parsedDate;
  }

  const inclusiveEnd = new Date(parsedDate);
  inclusiveEnd.setDate(inclusiveEnd.getDate() + 1);
  return inclusiveEnd;
};

export const hasActiveDiscount = (item, referenceDate = new Date()) => {
  if (
    !item?.discount ||
    item.discount <= 0 ||
    item.discount_type !== "porcentaje"
  ) {
    return false;
  }

  const start = item.discount_start_date
    ? new Date(item.discount_start_date)
    : null;
  const end = getInclusiveDiscountEnd(item.discount_end_date);
  const now = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);

  if (Number.isNaN(now.getTime())) {
    return false;
  }

  if (start && Number.isNaN(start.getTime())) {
    return false;
  }

  if (item.discount_end_date && !end) {
    return false;
  }

  if (start && now < start) {
    return false;
  }

  if (end && now >= end) {
    return false;
  }

  return true;
};
